// src/components/ResetPasswordForm.js
import React, { useState } from 'react';
import { getAuth, confirmPasswordReset } from 'firebase/auth';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './ResetPasswordForm.css';

const ResetPasswordForm = () => {
  const [searchParams] = useSearchParams();
  const oobCode = searchParams.get('oobCode');
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');

  const handleReset = async () => {
    const auth = getAuth();
    try {
      await confirmPasswordReset(auth, oobCode, password);
      setMessage('Contraseña restablecida. Redirigiendo...');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setMessage('Error al restablecer contraseña.');
    }
  };

  return (
    <div className="reset-wrapper">
      <div className="reset-box">
        <h2>Restablecer Contraseña</h2>
        <input
          type="password"
          placeholder="Nueva contraseña"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button onClick={handleReset}>Restablecer</button>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default ResetPasswordForm;
